import React, { useState } from 'react';
import Sidebar from './Sidebar.js';
import AdminHeader from './Header.js';
import { Card, Row, Col, Container, Button } from 'react-bootstrap';
import Breadcrumb from './Breadcrumb.js';
import occupations from './data/occupations.js';
import { Modal } from 'react-bootstrap';
import { FiClipboard } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';

const MappingSubOccupationView = () => {

    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalTitle, setModalTitle] = useState('');

    const { code } = useParams();
  
    const findOccupationByCode = (nodes, targetCode) => {
        for (const node of nodes) {
            if (node.code === targetCode) return node;
            if (node.children) {
                const found = findOccupationByCode(node.children, targetCode);
                if (found) return found;
            }
        }
        return null;
    };
    
    const selectedOccupation = findOccupationByCode(occupations, code);
    const subOccupations = selectedOccupation?.children || [];

    return (
        <>
            <AdminHeader />
            <Container className="pt-2">
                <Row>
                    <Col xs={2} className="p-0">
                    </Col>
                    <Col xs={10} className="p-0">
                        <Breadcrumb />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col xs={3} className="p-0">
                        <Sidebar />
                    </Col>

                    <Col xs={9} className="p-4">
                        <Card>
                            <Card.Body>
                                <h1 className="mb-3">Sub Occupations of: {selectedOccupation?.title || 'Unknown'}</h1>
                                <Row className="mb-4">
                                    <Col>
                                        {subOccupations.map((subOccupation, index) => (
                                            <Row>
                                                <Col md={12}>
                                                    <p className="form-control-plaintext">
                                                        {subOccupation.title} &nbsp;
                                                        {subOccupation.code}  &nbsp;
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Tasks - ' + subOccupation.title);
                                                                setModalContent(subOccupation.tasks || 'No tasks description available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View tasks"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Included occupations - ' + subOccupation.title);
                                                                setModalContent(subOccupation.includedOccupations || 'No included occupations available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View Included occupations"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Encluded occupations - ' + subOccupation.title);
                                                                setModalContent(subOccupation.excludedOccupations || 'No excluded occupations available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View excluded occupations"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Notes - ' + subOccupation.title);
                                                                setModalContent(subOccupation.notes || 'No notes available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View notes occupations"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        {subOccupation.children?.length > 0 && (
                                                            <Button
                                                                variant="secondary"
                                                                onClick={() => navigate(`/mapping-occupation/${subOccupation.code}/suboccupation`)}
                                                            >
                                                                Sub Occupation
                                                            </Button>
                                                        )}
                                                    </p>
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end gap-2 px-4">
                        <Button
                            variant="secondary"
                            onClick={() => {
                                if (code.length > 1) {
                                const parentCode = code.slice(0, -1);
                                    navigate(`/mapping-occupation/${parentCode}/suboccupation`);
                                } else {
                                    navigate('/mapping-occupation-view');
                                }
                            }}
                        >
                            Back
                        </Button>
                    </Col>
                </Row>
            </Container>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle} {}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{modalContent}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default MappingSubOccupationView;
